var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrdi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white",
    fillOpacity: 0.06
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.625 25.5631C14.625 24.3861 14.1437 24.0919 12.2875 24.0919H9.95L9.675 20.0459C9.60625 17.8391 9.60625 14.1609 9.675 11.9541L9.95 7.90814H12.2875C14.2125 7.90814 14.625 7.61389 14.625 6.36333C14.625 4.89208 14.35 4.81852 11.3937 5.18633C7.54375 5.62771 6.375 7.02539 6.375 11.3656C6.375 13.1311 6.1 14.5288 5.6875 14.5288C5.34375 14.5288 5 15.1908 5 16C5 16.8092 5.34375 17.4712 5.6875 17.4712C6.1 17.4712 6.375 18.8689 6.375 20.6344C6.375 25.3424 7.81875 26.8872 12.425 26.9608C14.2125 27.0344 14.625 26.7401 14.625 25.5631ZM24.7313 25.1217C25.2125 24.3861 25.625 22.3999 25.625 20.6344C25.625 18.8689 25.9688 17.4712 26.3125 17.4712C26.725 17.4712 27 16.8092 27 16C27 15.1908 26.725 14.5288 26.3125 14.5288C25.9688 14.5288 25.625 13.1311 25.625 11.3656C25.625 7.02539 24.4563 5.62771 20.6063 5.18633C17.65 4.81852 17.375 4.89208 17.375 6.36333C17.375 7.61389 17.7875 7.90814 19.7125 7.90814H22.05L22.325 11.9541C22.3938 14.1609 22.3938 17.8391 22.325 20.0459L22.05 24.0919H19.7125C17.7875 24.0919 17.375 24.3861 17.375 25.6367C17.375 27.1079 17.65 27.1815 20.6063 26.8137C22.6 26.593 24.1813 25.9309 24.7313 25.1217ZM18.75 18.9425C19.5062 18.1333 20.125 16.8092 20.125 16C20.125 14.0874 17.7875 11.5863 16 11.5863C14.2125 11.5863 11.875 14.0874 11.875 16C11.875 16.8092 12.4937 18.1333 13.25 18.9425C14.0062 19.7517 15.2437 20.4137 16 20.4137C16.7562 20.4137 17.9937 19.7517 18.75 18.9425Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3214 17.1917C13.6339 15.2791 14.5964 13.6607 16.2464 13.955C18.5152 14.2492 18.5152 17.7802 16.2464 18.0744C15.3527 18.2216 14.5277 17.8538 14.3214 17.1917Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrdi);
export default __webpack_public_path__ + "static/media/ORDI.9bc37c0740041300ca9c1ae16cfdf85e.svg";
export { ForwardRef as ReactComponent };